export const conf = {
    apiURL: "https://api-panel-franquicias.amarilio.net/",
    states: [
        {
            "name": "Distrito Federal",
        },
        {
            "name": "Aguascalientes",
        },
        {
            "name": "Baja California",
        },
        {
            "name": "Baja California Sur",
        },
        {
            "name": "Campeche",
        },
        {
            "name": "Chiapas",
        },
        {
            "name": "Chihuahua",
        },
        {
            "name": "Coahuila",
        },
        {
            "name": "Colima",
        },
        {
            "name": "Durango",
        },
        {
            "name": "Guanajuato",
        },
        {
            "name": "Guerrero",
        },
        {
            "name": "Hidalgo",
        },
        {
            "name": "Jalisco",
        },
        {
            "name": "Michoacán",
        },
        {
            "name": "Morelos",
        },
        {
            "name": "México",
        },
        {
            "name": "Nayarit",
        },
        {
            "name": "Nuevo León",
        },
        {
            "name": "Oaxaca",
        },
        {
            "name": "Puebla",
        },
        {
            "name": "Querétaro",
        },
        {
            "name": "Quintana Roo",
        },
        {
            "name": "San Luis Potosí",
        },
        {
            "name": "Sinaloa",
        },
        {
            "name": "Sonora",
        },
        {
            "name": "Tabasco",
        },
        {
            "name": "Tamaulipas",
        },
        {
            "name": "Tlaxcala",
        },
        {
            "name": "Veracruz",
        },
        {
            "name": "Yucatán",
        },
        {
            "name": "Zacatecas",
        }
    ]
}